import { useCallback, useState } from 'react';

interface Props {
  src: string;
  alt: string;
  className: string;
  link?: any;
  onFirstImageLoad?: () => void;
}

function ImageContainer({ src, alt, className, onFirstImageLoad, link }: Props) {
  const [loading, setLoading] = useState(true);
  
  const handleImageLoad = useCallback(() => {
    setLoading(false);
    if (onFirstImageLoad) {
      onFirstImageLoad();
    }
  }, [onFirstImageLoad]);
  
  if (src == "/image/home/GK-2-Year-Celebration-Website-Banner-1-[28-04-2025].jpg") { 
    return (
      <a target='_blank' href="https://goldkinen.com/goldkinengoldjiten?utm_source=website&utm_medium=website&utm_campaign=goldkinengoldjiten">
        <img
        key={src}
        src={src}
        alt={alt}
        className={`${className} transition duration-300 ease-in-out ${
          loading ? 'bg-gray-600/40 animate-pulse rounded-md' : 'opacity-100'
        }`}
        onLoad={handleImageLoad}
        loading={onFirstImageLoad ? "eager" : "lazy"} // Load first image eagerly

        
      />
      </a>
    );
  }
  return (
   <img
      src={src}
      alt={alt}
      className={`${className} transition duration-300 ease-in-out ${
        loading ? 'bg-gray-600/40 animate-pulse rounded-md' : 'opacity-100'
      }`}
      onLoad={handleImageLoad}
      loading={onFirstImageLoad ? "eager" : "lazy"} // Load first image eagerly

      
    />
  )

  // return (
    
  //     <img
  //     src={src}
  //     alt={alt}
  //     className={`${className} transition duration-300 ease-in-out ${
  //       loading ? 'bg-gray-600/40 animate-pulse rounded-md' : 'opacity-100'
  //     }`}
  //     onLoad={handleImageLoad}
  //     loading={onFirstImageLoad ? "eager" : "lazy"} // Load first image eagerly

      
  //   />
    
  // );
}

export default ImageContainer;